/**
 * Adds Bootstrap's `img-fluid` class to every new GrapesJS image block.
 *
 * @param {Object} editor
 */
const imageDefaultsPlugin = editor => {
  editor.DomComponents.addType('image', {
    model: {
      defaults: {
        classes: ['img-fluid'],
      },
    },
  })

  const block = editor.BlockManager.get('image')

  if (!block) {
    return
  }

  const content = block.get('content')

  if (content && typeof content === 'object' && !Array.isArray(content)) {
    block.set('content', {
      ...content,
      classes: ['img-fluid'],
    })
  }
}

export default imageDefaultsPlugin
